import React from 'react';

/**
 * Renders the active event's FAQ. Shared by the issuer modal and the public
 * volunteer page so the two cannot drift apart.
 *
 * The HTML comes from the WYSIWYG on the event form, which is a draft-js editor
 * -- its output cannot carry <script> or event handlers, which is why this is
 * injected rather than sanitized. Anything that starts storing FAQ HTML from
 * another source needs to revisit that.
 */
export const FaqContent = ({ loading, faq, emptyMessage = 'No FAQ has been added for this event yet.' }) => {
    if (loading) {
        return (
            <div className="text-center py-4">
                <div className="spinner-border text-primary" role="status">
                    <span className="visually-hidden">Loading...</span>
                </div>
            </div>
        )
    }

    // An editor emptied of text still serializes as markup, so a blank FAQ
    // arrives as something like "<p></p>\n" rather than null.
    const hasContent = faq && faq.replace(/<[^>]*>/g, '').replace(/&nbsp;/g, ' ').trim() !== ''

    if (! hasContent) {
        return (
            <div className="text-muted text-center py-4">
                <i className="mdi mdi-help-circle-outline d-block font-size-24 mb-2"></i>
                {emptyMessage}
            </div>
        )
    }

    return <div className="faq-content" dangerouslySetInnerHTML={{ __html: faq }} />
};
